import React from "react";
import { Apple, MapPin, Play } from "lucide-react";

const Footer = ({ showPage }) => {
  const handlePricingClick = (e) => {
    e.preventDefault();
    const pricingSection = document.getElementById("pricing");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    } else {
      showPage("/");
      setTimeout(() => {
        document
          .getElementById("pricing")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <footer className="bg-neutral-900 border-t border-neutral-800 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/bilmwhite.png" alt="Bilm" width="80" />
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-4">
              Modern property management for residents and managers across
              Nigeria.
            </p>
            <div className="flex items-center gap-2 text-neutral-500 text-xs">
              <MapPin className="w-3 h-3 shrink-0" />
              <span>Lagos, Nigeria</span>
            </div>
          </div>
          <div>
            <h4 className="font-heading font-bold text-white text-sm mb-4">
              Product
            </h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => showPage("/residents")}
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  For Residents
                </button>
              </li>
              <li>
                <button
                  onClick={() => showPage("/managers")}
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  For Managers
                </button>
              </li>
              <li>
                <button
                  onClick={handlePricingClick}
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => showPage("/features")}
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  Features
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-bold text-white text-sm mb-4">
              Help
            </h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => showPage("/support")}
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  Support Center
                </button>
              </li>
              <li>
                <button
                  onClick={() => showPage("/articles")}
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  Help Articles
                </button>
              </li>
              <li>
                <a
                  href="mailto:support@bilm.app"
                  className="text-neutral-400 hover:text-white text-sm transition-colors"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-bold text-white text-sm mb-4">
              Download
            </h4>
            <div className="space-y-2 mb-6">
              <a
                href="https://apps.apple.com/ng/app/bilm/id6471915924"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-neutral-400 hover:text-white text-sm transition-colors"
              >
                <Apple className="w-4 h-4" /> App Store
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.builm&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-neutral-400 hover:text-white text-sm transition-colors"
              >
                <Play className="w-4 h-4" /> Google Play
              </a>
            </div>
            <h4 className="font-heading font-bold text-white text-sm mb-3">
              Follow Us
            </h4>
            <div className="flex items-center gap-3">
              <a
                href="https://twitter.com/bilmapp"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg bg-neutral-800 hover:bg-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white transition-colors text-xs font-bold"
              >
                X
              </a>
              <a
                href="https://instagram.com/bilmapp"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg bg-neutral-800 hover:bg-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white transition-colors text-xs font-bold"
              >
                IG
              </a>
              <a
                href="https://linkedin.com/company/builm"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg bg-neutral-800 hover:bg-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white transition-colors text-xs font-bold"
              >
                In
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-neutral-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            &copy; 2026 Builm Ltd. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button
              onClick={() => showPage("/privacy")}
              className="text-neutral-500 hover:text-white text-sm transition-colors"
            >
              Privacy
            </button>
            <button
              onClick={() => showPage("/terms")}
              className="text-neutral-500 hover:text-white text-sm transition-colors"
            >
              Terms
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
